import Layout from 'app/layouts/Layout'
import { MaintenanceMode } from 'app/components/MaintenanceMode'
import { useAppSelector } from 'app/services/hooks/store-hooks'
import AuthGuard from 'app/services/guards/AuthGuard'
import { Navigate, RouteObject, useRoutes } from 'react-router-dom'
import templateHistoryRoutes from './templateHistory.routes'
import templateConfigurationRoutes from './templateConfiguration.routes'
import homeRoutes from './home.routes'
import faqRoutes from './faq.routes'
import accessManagementRoutes from './accessManagement.routes'
import dataManipulationRoutes from './dataManipulation.routes'

const routes: RouteObject[] = [
  {
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      ...homeRoutes,
      ...templateConfigurationRoutes,
      ...templateHistoryRoutes,
      ...faqRoutes,
      ...accessManagementRoutes,
      ...dataManipulationRoutes,
    ],
  },
  { path: '*', element: <Navigate to='/' /> }, // TODO : update to show some error page
]

export function GlobalRoutes() {
  const { isActive, message } = useAppSelector((state) => state.maintenance)
  const routeTree = useRoutes(routes)

  if (isActive) {
    return <MaintenanceMode message={message} />
  }

  return routeTree
}
